import React, {useState} from 'react';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import {Label, Row} from 'reactstrap';
import ESimInfo from '../../Constans/ESimInfo';
function OnlySimProcess(props) {
  const {isAllowedEsim, simType, setSimType, isShowEsim} = props;
  const whatIsEsimPopupTextList = props.contentData.esimContentData?.expandedValue?.[0]?.whatIsEsimPopupText?.value;
  const cellularDevicesSupportedUrl = props.contentData.esimContentData?.expandedValue?.[0]?.cellularDevicesSupportedUrl?.value;
  // const whatIsEsimUrl = props.contentData.whatIsEsimUrl.value;
  // const isMyDeviceSupportUrl = props.contentData.isMyDeviceSupportEsimUrl.value;

  return (
    <div className='only-sim-process'>
      <Row className='idf-sub-title-bold justify-content-center d-flex'>איזה סוג SIM תרצו?</Row>
      <div className='radio-input-container'>
        <RadioInput
          checked={simType === 'SIM'}
          id={'sim'}
          name={'simType'}
          value={'SIM'}
          label={'SIM רגיל'}
          onRadioChange
          onChange={(e) => setSimType(e.target.value)}
        />
        {isAllowedEsim() && (
          <RadioInput
            checked={simType === 'eSIM'}
            id={'esim'}
            name={'simType'}
            value={'eSIM'}
            label={'eSIM'}
            price={`₪0`}
            badge={'חדש'}
            onChange={(e) => setSimType(e.target.value)}
          />
        )}
        {isAllowedEsim() && (
          <div className='info-container'>
            <ESimInfo
              cellularDevicesSupportedUrl={cellularDevicesSupportedUrl}
              whatIsEsimPopupTextList={whatIsEsimPopupTextList}></ESimInfo>
          </div>
        )}
      </div>
    </div>
  );
}

export default OnlySimProcess;
